export default __webpack_public_path__ + "static/BeTRITON-black-67236dc5aeb60d6c47d2ea6725618c41.png";